const RETURN_KEY = 'mycrashpro:instructions-after-refresh';
function validRelease(value) {
  return Boolean(value && typeof value === 'object' &&
    typeof value.version === 'string' && /^\d+\.\d+\.\d+$/.test(value.version) &&
    typeof value.releaseKey === 'string' && value.releaseKey.length > 0 && value.releaseKey.length <= 180 &&
    typeof value.instructionsRevision === 'string' && /^[0-9.\-]+$/.test(value.instructionsRevision) &&
    typeof value.readOnly === 'boolean');
}
const readKey = userId => `mycrashpro:instructions-read:${userId}`;
function browserStorage(browser, name) { try { return browser[name]; } catch { return null; } }
const instructionAudience = user => ['inventory', 'serviceIncome'].map(name => `${name}:${user?.permissions?.[name]?.view === true ? 1 : 0}`).join(',');
function readStored(storage, key) { try { return storage.getItem(key); } catch { return null; } }
function store(storage, key, value) { try { storage.setItem(key, value); return true; } catch { return false; } }
function consumeReturn(storage, userId) {
  const value = readStored(storage, RETURN_KEY);
  if (!value || !userId) return false;
  try { storage.removeItem(RETURN_KEY); } catch { /* The query alone never grants an acknowledgement. */ return false; }
  return value === String(userId);
}
module.exports = { RETURN_KEY, validRelease, readKey, readStored, store, consumeReturn, browserStorage, instructionAudience };
